import { rankingData } from '@/mocks/tanhua';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            热门榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            实时热度排行，发现当前最受欢迎的国产探花系列作品
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {rankingData.map((item) => (
            <a
              key={item.id}
              href="#media"
              className="flex items-center gap-4 p-4 hover:bg-background-100 transition-colors border-b border-background-200/60 last:border-b-0 cursor-pointer group"
            >
              <div className="flex items-center justify-center w-10 h-10 flex-shrink-0">
                {item.rank <= 3 ? (
                  <span className={`text-lg font-heading ${
                    item.rank === 1
                      ? 'text-accent-500'
                      : item.rank === 2
                      ? 'text-foreground-400'
                      : 'text-secondary-500'
                  }`}>
                    {item.rank}
                  </span>
                ) : (
                  <span className="text-base text-foreground-500 font-medium">{item.rank}</span>
                )}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-sm md:text-base text-foreground-800 font-medium truncate group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </span>
                  <span className="text-xs px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>

              <div className="flex items-center gap-3 flex-shrink-0">
                <span className="text-xs md:text-sm text-foreground-600 whitespace-nowrap">
                  {item.views} 次观看
                </span>
                <span className={`text-sm ${
                  item.trend === 'up'
                    ? 'text-primary-500'
                    : item.trend === 'down'
                    ? 'text-foreground-400'
                    : 'text-foreground-500'
                }`}>
                  {item.trend === 'up' ? '↑' : item.trend === 'down' ? '↓' : '→'}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}